module.exports = __webpack_public_path__ + "img/modal_add_new_word.5e881d4a.jpg";